import React, {useEffect, useState} from "react";
import useToastNotify from "../../../hook/useToastNotify";
import {useHistory, useLocation} from "react-router-dom";
import {IPagesProps} from "../../../contracts/pages";
import httpClient from "../../../services/httpClient";
import {commentsApi, podcastsApi, purchasesApi, usersApi, videoProductApi, videosApi} from "../../../constans/apiUrls";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import Badge from "../../Elements/Badge";
import {badgeType, RouterStateSectionType} from "../../../constans/enumTypes";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import Table from "../../Elements/Table";
import TableEmpty from "../../Elements/Table/TableEmpty";
import MyPagination from "../../Elements/MyPagination";
import useQuery from "../../../hook/useQuery";
import {
    generatePaidStatusTitle,
    generateMethodPaymentTitle,
    isNotEmpty,
    priceFormatWithUnitToman,
    generateTypeVideoProductTitle,
    generateStatusVideoProductTitle,
    generateVideoLinkTypeTitle,
    generateVideoProductLikeTypeTitle
} from "../../../helpers/functions";
import {IPurchaseListData, IUserPurchaseListData} from "../../../contracts/data/purchase";
import { AiOutlineEye } from "react-icons/ai";
import PageHeader from "../../Elements/PageHeader";
import {IRouterListToData} from "../../../contracts/data/router";
import {
    IVideoProductLikeForUserData,
    IVideoProductListData,
    IVideoProductRateForUserData,
    IVideoProductUserListData
} from "../../../contracts/data/video_product";
import {MdOutlineLoop} from "react-icons/md";
import MyModal from "../../Elements/MyModal";
import AddVideoProductToUserForm from "../../../forms/dashboard/video_product/AddVideoProductToUserForm";
import {IVideoListData, IVideoRateForUserData} from "../../../contracts/data/video";
import {IPodcastListData, IPodcastRateForUserData} from "../../../contracts/data/podcast";

const UserLike:React.FC<IPagesProps> = () => {
    const {toastNotify} = useToastNotify();
    const history = useHistory()
    const location = useLocation<IRouterListToData>()
    const queryParams = useQuery()
    // const [dataPodcasts, setDataPodcasts] = useState<Array<IPodcastRateForUserData>>([]);
    // const [dataVideos, setDataVideos] = useState<Array<IVideoRateForUserData>>([]);
    const [dataVideosProducts, setDataVideosProducts] = useState<Array<IVideoProductLikeForUserData>>([]);
    // const [loadingPodcasts, setLoadingPodcasts] = useState<boolean>(true);
    // const [loadingVideos, setLoadingVideos] = useState<boolean>(true);
    const [loadingVideosProducts, setLoadingVideosProducts] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);

    // const titleHeadPodcastsTable: Array<string> = ['#', 'عنوان', 'امتیاز']
    // const titleHeadVideosTable: Array<string> = ['#', 'عنوان', 'امتیاز']
    const titleHeadVideoProductTable: Array<string> = ['#', 'عنوان محصول', 'امتیاز']

    const fetchItemsDataVideosProducts = async (search: string | null | undefined = "") => {
        await httpClient().get(`${videoProductApi.user_like_list}/${queryParams.get('id')}`)
            .then(response => {
                if(response.status === 200){
                    setDataVideosProducts(response.data)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoadingVideosProducts(false))
    }

    // const fetchItemsDataVideos = async (search: string | null | undefined = "") => {
    //     await httpClient().get(`${videosApi.user_rate_list}/${queryParams.get('id')}`)
    //         .then(response => {
    //             if(response.status === 200){
    //                 setDataVideos(response.data)
    //             }
    //         })
    //         .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
    //         .finally(() => setLoadingVideos(false))
    // }
    //
    // const fetchItemsDataPodcasts = async (search: string | null | undefined = "") => {
    //     await httpClient().get(`${podcastsApi.user_rate_list}/${queryParams.get('id')}`)
    //         .then(response => {
    //             if(response.status === 200){
    //                 setDataPodcasts(response.data)
    //             }
    //         })
    //         .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
    //         .finally(() => setLoadingPodcasts(false))
    // }

    useEffect(() => {
        fetchItemsDataVideosProducts()
        // fetchItemsDataVideos()
        // fetchItemsDataPodcasts()
    }, [])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableVideosProductsRows = dataVideosProducts.map((item, index) =>
        <TableTr key={`table-videos-products-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.title} hasImage={true} image={item?.image}/></TableTd>
            <TableTd><TableTdContent content={generateVideoProductLikeTypeTitle(item?.type)}/></TableTd>
        </TableTr>
    )

    // const itemsTableVideosRows = dataVideos.map((item, index) =>
    //     <TableTr key={`table-videos-row${index}`}>
    //         <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
    //         <TableTd><TableTdContent content={item?.video_title} /></TableTd>
    //         <TableTd><TableTdContent content={item?.rate}/></TableTd>
    //     </TableTr>
    // )
    //
    // const itemsTablePodcastsRows = dataPodcasts.map((item, index) =>
    //     <TableTr key={`table-podcasts-row${index}`}>
    //         <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
    //         <TableTd><TableTdContent content={item?.podcast_title} /></TableTd>
    //         <TableTd><TableTdContent content={item?.rate}/></TableTd>
    //     </TableTr>
    // )

    return(
        <React.Fragment>
            <PageHeader title={`لیست لایک های "${isNotEmpty(queryParams.get('name')) ? queryParams.get('name') : ""}"`} isBackBtn
                        urlBackBtn={`${(typeof location?.state?.page !== 'undefined') ? location?.state?.page : "/dashboard/users/list"}?page_num=${(typeof location?.state?.page_num !== 'undefined') ? location?.state?.page_num : 1}`}
            />
            <div className={"mb-8"}>
                <Table isLoading={loadingVideosProducts} title={'لیست محصولات ویدیویی'} subTitle={`تعداد کل: ${dataVideosProducts.length}`}
                       titlesTable={titleHeadVideoProductTable} isSearch={false}>
                    {itemsTableVideosProductsRows.length > 0 ? itemsTableVideosProductsRows :
                        <TableEmpty colSpan={titleHeadVideoProductTable.length} message={"محصول ویدیویی یافت نشد"}/>}
                </Table>
            </div>
            {/*<div className={"mb-8"}>*/}
            {/*    <Table isLoading={loadingVideos} title={'لیست ویدیو ها'} subTitle={`تعداد کل: ${dataVideos.length}`}*/}
            {/*           titlesTable={titleHeadVideosTable} isSearch={false}>*/}
            {/*        {itemsTableVideosRows.length > 0 ? itemsTableVideosRows :*/}
            {/*            <TableEmpty colSpan={titleHeadVideosTable.length} message={"ویدیویی یافت نشد"}/>}*/}
            {/*    </Table>*/}
            {/*</div>*/}
            {/*<div className={"mb-8"}>*/}
            {/*    <Table isLoading={loadingPodcasts} title={'لیست پادکست ها'} subTitle={`تعداد کل: ${dataPodcasts.length}`}*/}
            {/*           titlesTable={titleHeadPodcastsTable} isSearch={false}>*/}
            {/*        {itemsTablePodcastsRows.length > 0 ? itemsTablePodcastsRows :*/}
            {/*            <TableEmpty colSpan={titleHeadPodcastsTable.length} message={"پادکستی یافت نشد"}/>}*/}
            {/*    </Table>*/}
            {/*</div>*/}
        </React.Fragment>
    )
}

export default UserLike